import { isUndefined } from '@antfu/utils';

export const setupGuards = router => {
  // 👉 router.beforeEach
  // Docs: https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
  router.beforeEach(to => {
    // Se a rota exigir autenticação e o token não existir, redireciona para a página de login
    if ((isUndefined(to.meta.requiresAuth) || to.meta.requiresAuth) && !useCookie('Authorization').value) {
      return { name: 'dashboard-login' }  // Altere 'Login' para o nome da sua rota de login
    }

    // Caso contrário, continua com a navegação
    return true

  })
}
